import React, { useEffect } from 'react';
import { Formik, Form, Field, ErrorMessage } from 'formik';
import { Button, Box, Typography, Divider } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { FlexContainer } from '@/components/containers/FlexContainer/FlexContainer';
import { sendWelcomeEmail } from '@/services/emailService';
import LoginSuccessModal from '@/components/pages/Login/modals/LoginSuccessModal';
import { GoogleLogin } from '@react-oauth/google';
import { useDispatch } from 'react-redux';
import { setUser } from '@/redux/actions/userActions';
import { Link } from 'react-router-dom';
import Label from '@/components/form/Label/Label';

const SearchBar = (props) => {
  const { languageData, onBack } = props;
  return (
    <FlexContainer className={'margt60 align-items-end'}>
      <i class="fa fa-chevron-left" onClick={onBack}></i>
      <Label className={'fontWhite text-12 margl10'} onClick={onBack}>
        {languageData === 'EN' ? 'Back to menu' : 'Volver al menú'}
      </Label>
    </FlexContainer>
  );
};

const LoginForm = (props) => {
  const {
    initialValues,
    onSubmit,
    loading,
    languageData,
    error,
    googleError,
    onGoogleLogin,
    successMessage,
    validationSchema,
  } = props;

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const handleSuccess = async (credentialResponse) => {
    try {
      const idToken = credentialResponse.credential;

      console.log('ID Token de Google:', idToken);

      const base64Url = idToken.split('.')[1];
      const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
      const jsonPayload = decodeURIComponent(
        window
          .atob(base64)
          .split('')
          .map((c) => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2))
          .join(''),
      );

      const googleUserDetails = JSON.parse(jsonPayload);

      const tokenData = await onGoogleLogin({
        email: googleUserDetails.email,
        googleToken: idToken,
      });

      console.log('Token OAuth recibido:', tokenData);

      const userData = {
        name: googleUserDetails?.name,
        lastName: '',
        email: googleUserDetails?.email,
        user_id: tokenData?.user_details?.user_id || 2,
        google: true,
      };

      if (tokenData?.isFirstGoogleLogin) {
        const templateParams = {
          user_name: userData.name,
          user_email: userData.email,
          reply_to: userData.email,
          copy_to: 'sistemas@popnest.org',
          message:
            'Estimado usuario esto es una prueba en todo caso no responder este mensaje , sea bienvenido a Popnest',
        };

        sendWelcomeEmail(templateParams)
          .then(() => console.log('Email de bienvenida enviado correctamente'))
          .catch((err) => console.error('Error enviando email de bienvenida:', err));
      }

      dispatch(setUser(userData));

      localStorage.setItem('user', JSON.stringify(userData));
      localStorage.setItem('access_token', tokenData.access_token);
      localStorage.setItem('refresh_token', tokenData.refresh_token);
      localStorage.setItem(
        'auth_data',
        JSON.stringify({
          token_type: tokenData.token_type,
          expires_in: tokenData.expires_in,
          scope: tokenData.scope,
        }),
      );
      setTimeout(() => {
        window.scrollTo(0, 0);
      }, 0);
    } catch (error) {
      console.error('Error en login con Google:', error);
    }
  };

  const handleError = () => {
    console.log('Login Failed');
  };

  return (
    <FlexContainer className={'flex-column margb20 height-610px'}>
      <Formik initialValues={initialValues} onSubmit={onSubmit} validationSchema={validationSchema}>
        {({ isSubmitting }) => (
          <FlexContainer className={'flex-column align-items-center'}>
            <Form className="align-items-center format50 m-format100">
              <Box mb={3}>
                <Field
                  type="email"
                  name="email"
                  placeholder={
                    languageData === 'EN'
                      ? 'Enter your email address'
                      : 'Ingresa tu correo electrónico'
                  }
                  className={
                    'border-rad8px grayShadowBottom placeholder-custom boxSizing_borderBox pad14 width100 text-15 fontWhite outlineNone'
                  }
                  style={{
                    backgroundColor: 'rgba(255,255,255,0)',
                    border: '2px solid rgba(255,255,255,0.4)',
                    transition: 'all 0.2s ease',
                  }}
                  onBlur={(e) => {
                    e.target.style.backgroundColor = 'rgba(255,255,255,0.12)';
                    e.target.style.borderColor = 'rgba(255,255,255,0.3)';
                    e.target.style.boxShadow = '0 2px 4px rgba(0, 0, 0, 0.1)';
                  }}
                />
                <ErrorMessage name="email" component="div" className="fontRed100 margt8 text-13" />
              </Box>
              <Box mb={3} position="relative">
                <Field
                  type="password"
                  name="password"
                  placeholder={
                    languageData === 'EN' ? 'Enter your password' : 'Ingresa tu contraseña'
                  }
                  className={
                    'border-rad8px grayShadowBottom placeholder-custom boxSizing_borderBox pad14 width100 text-15 outlineNone fontWhite'
                  }
                  style={{
                    backgroundColor: 'rgba(255,255,255,0)',
                    border: '2px solid rgba(255,255,255,0.4)',
                    transition: 'all 0.2s ease',
                  }}
                  onBlur={(e) => {
                    e.target.style.backgroundColor = 'rgba(255,255,255,0.12)';
                    e.target.style.borderColor = 'rgba(255,255,255,0.3)';
                    e.target.style.boxShadow = '0 2px 4px rgba(0, 0, 0, 0.1)';
                  }}
                />
                <ErrorMessage
                  name="password"
                  component="div"
                  className="fontRed100 margt8 text-13"
                />
                <Typography
                  variant="caption"
                  className="block  pointer text-right lineHeight-1-6"
                  sx={{
                    mt: 2,
                    fontSize: '13px',
                    color: 'rgba(255,255,255,0.85)',
                    fontWeight: 500,
                    '&:hover': {
                      color: 'white',
                      textDecoration: 'underline',
                    },
                  }}
                >
                  {languageData === 'EN' ? 'Forgot password?' : '¿Olvidaste tu contraseña?'}
                </Typography>
              </Box>
              {loading && (
                <Label className={'text-22'}>
                  {languageData === 'EN'
                    ? 'Loading... please, wait'
                    : 'Cargando... por favor, espere'}
                </Label>
              )}
              {successMessage && (
                <Label className={'text-16 fontGreenG200 text-center text-weight-800'}>
                  <i class="fa-solid fa-check" style={{ marginRight: '8px' }}></i>{' '}
                  {languageData === 'EN'
                    ? 'Has iniciado sesión correctamente'
                    : 'You have successfully logged in'}
                </Label>
                /* <Label
                className="text-18"
                style={{ color: '#ff6b6b', marginTop: '10px' }}
              >
                {error}
              </Label> */
              )}
              {error && (
                <Label className={'text-16 fontRed075 text-center text-weight-800'}>
                  <i class="fa-solid fa-x" style={{ marginRight: '8px' }}></i>{' '}
                  {languageData === 'EN'
                    ? 'Incorrect username or password'
                    : 'Usuario o contraseña incorrecta'}
                </Label>
                /* <Label
                className="text-18"
                style={{ color: '#ff6b6b', marginTop: '10px' }}
              >
                {error}
              </Label> */
              )}
              {googleError && (
                <Label className="text-16 fontRed075 text-center text-weight-800">
                  <i className="fa-solid fa-circle-exclamation" style={{ marginRight: 8 }}></i>
                  {googleError}
                </Label>
              )}
              <Button
                className={'bgGradientSignUpPurple '}
                type="submit"
                fullWidth
                sx={{
                  mt: '10px',
                  py: 0.8,
                  color: 'white',
                  borderRadius: '10px',
                  textTransform: 'none',
                  transition: 'all 0.2s ease',
                  fontSize: '20px',
                  '&:hover': {
                    boxShadow: '0 6px 16px rgba(248, 87, 166, 0.5)',
                    transform: 'translateY(-1px)',
                  },
                  '&:disabled': {
                    opacity: 0.7,
                  },
                }}
                disabled={loading || isSubmitting}
              >
                {loading
                  ? languageData === 'EN'
                    ? 'Loading...'
                    : 'Cargando...'
                  : languageData === 'EN'
                  ? 'Sign In'
                  : 'Iniciar Sesión'}
              </Button>
              <Box display="flex" alignItems="center" justifyContent="center">
                <Divider
                  sx={{
                    flexGrow: 1,
                    borderColor: 'rgba(255,255,255,0.25)',
                    borderWidth: 1,
                  }}
                />
                <Typography
                  variant="body2"
                  className={'padl16 padr16 '}
                  sx={{
                    color: 'rgba(255,255,255,0.7)',
                    fontSize: '13px',
                    fontWeight: 500,
                  }}
                >
                  {languageData === 'EN' ? 'OR' : 'O'}
                </Typography>
                <Divider
                  sx={{
                    flexGrow: 1,
                    borderColor: 'rgba(255,255,255,0.25)',
                    borderWidth: 1,
                  }}
                />
              </Box>
              <FlexContainer className={'width100 justify-center'}>
                <div
                  style={{
                    maxWidth: '330px',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                  }}
                >
                  <GoogleLogin
                    onSuccess={handleSuccess}
                    onError={handleError}
                    useOneTap
                    theme="outline"
                    shape="pill"
                    size="large"
                    text="continue_with"
                    width="330"
                    logo_alignment="left"
                  />
                </div>
              </FlexContainer>
              <FlexContainer className={'justify-center margt30 m-hide'}>
                <FlexContainer className={'width100 justify-center'}>
                  <Label className={'text-center'}>
                    {languageData === 'EN'
                      ? "Haven't registered yet?"
                      : '¿Aún no te has registrado?'}{' '}
                    <Link
                      to={languageData === 'EN' ? '/signup' : '/registrarse'}
                      className={'loginText'}
                    >
                      {languageData === 'EN' ? 'Register' : 'Registrarse'}
                    </Link>
                  </Label>
                </FlexContainer>
              </FlexContainer>
              <FlexContainer className={'justify-between margt30 padlr30 gap-10 d-hide'}>
                <FlexContainer className={'flex-column width100'}>
                  <Label>
                    {languageData === 'EN'
                      ? "Haven't registered yet?"
                      : '¿Aún no te has registrado?'}
                  </Label>
                </FlexContainer>
                <Link
                  to={languageData === 'EN' ? '/signup' : '/registrarse'}
                  className={'flex-column loginText width100'}
                >
                  {languageData === 'EN' ? 'Register' : 'Registrarse'}
                </Link>
              </FlexContainer>
            </Form>
          </FlexContainer>
        )}
      </Formik>
    </FlexContainer>
  );
};

const LoginView = (props) => {
  const {
    initialValues,
    onSubmit,
    loading,
    onBack,
    onGoogleLogin,
    onRegister,
    languageData,
    error,
    successMessage,
    success,
    validationSchema,
    googleError,
    showModal,
    goHome,
    goBack,
    closeModal,
    loginType,
  } = props;
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <FlexContainer className="flex-column padlr10 justify-start items-center  bgGradientBlue fontWhite">
      {!success && <SearchBar languageData={languageData} onBack={onBack} />}
      <FlexContainer className={'flex-column padlr20 margb30'}>
        {!success && (
          <>
            <FlexContainer
              className={'flex-column align-items-center width100 m-hide margt60 margb30'}
            >
              <Label className={'text-40 margt10'}>
                <strong>{languageData === 'EN' ? 'Login' : 'Iniciar sesión'}</strong>
              </Label>
              <Label className={'text-14 margtb10'}>
                {languageData === 'EN'
                  ? "Good to see you again. Let's get you back to work (and travel)"
                  : 'Qué bueno verte de nuevo. Volvamos al trabajo (y a viajar)'}
              </Label>
            </FlexContainer>
            <FlexContainer className={'flex-column d-hide'}>
              <Label className={'text-40 margt10'}>
                <strong>{languageData === 'EN' ? 'Login' : 'Iniciar sesión'}</strong>
              </Label>
              <Label className={'text-14 margtb10'}>
                {languageData === 'EN'
                  ? "Good to see you again. Let's get you back to work (and travel)"
                  : 'Qué bueno verte de nuevo. Volvamos al trabajo (y a viajar)'}
              </Label>
            </FlexContainer>
          </>
        )}
        <LoginForm
          languageData={languageData}
          onBack={onBack}
          initialValues={initialValues}
          validationSchema={validationSchema}
          onSubmit={onSubmit}
          success={success}
          loading={loading}
          successMessage={successMessage}
          onGoogleLogin={onGoogleLogin}
          onRegister={onRegister}
          error={error}
          googleError={googleError}
        />
        <LoginSuccessModal
          open={showModal}
          onClose={closeModal}
          onGoHome={goHome}
          onGoBack={goBack}
          loginType={loginType}
        />
      </FlexContainer>
    </FlexContainer>
  );
};

export default LoginView;
